import type { IBracketStore, } from "@store/types";
import { produce } from 'immer';
import type { StateCreator, } from "zustand";
import type { Store } from '../useStore';
import * as R from "./resolvers";
import type{ IPricingSlice, } from "./types";



export const createPricingSlice: StateCreator<IBracketStore, [], [], IPricingSlice> = ( set, get, ) => {

	const fetch = async () => {

		set(produce<Store>(state => {
			state.pricing.fetching = true;
		}));

		const rates = await R.getRates();
		const brktApy = await R.getBlockRewardsAPY();


		set(produce<Store>(state => {
			state.pricing.rates = rates;
			state.pricing.brktApy = brktApy;
			state.pricing.ready = true;
			state.pricing.fetching = false;
		}));

	}

	const reset = () => {
	};

	const resetAsync = async () => {
		reset();
	};

	// place at the bottom of the call stack.
	setTimeout(_ => fetch(), 0);

	return {
		brktApy: -1,
		ready: false,
		fetching: false,
		rates: {},
		fetch,
		reset,
		resetAsync,
	};

};

